import { Button } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    margin: 0 16px;
`;
